export const LOADER_STATUS = 'boilerplate/group/LOADER_STATUS';
export const GROUP_DATA = 'boilerplate/group/GROUP_DATA';
export const TOTAL_RECORD = 'boilerplate/group/TOTAL_RECORD'
export const GET_ALL_GROUPS = 'boilerplate/group/GET_ALL_GROUPS';